import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  useEffect(() => { api.get(`/cms/${slug}`).then(({ data }) => setPage(data)).catch(() => setPage({ title: "Not Found", content: "<p>Page not found.</p>" })); }, [slug]);
  if (!page) return <div className="min-h-[60vh]" />;
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 min-h-[60vh]" data-testid="cms-page">
      <h1 className="font-heading text-4xl font-bold text-navy mb-6">{page.title}</h1>
      <div className="prose max-w-none text-navy/80" dangerouslySetInnerHTML={{ __html: page.content }} />
    </div>
  );
}
